import {
  FileText,
  Siren,
  ClipboardCheck,
  HelpCircle,
  Newspaper,
  BookUser,
  Briefcase,
  Users,
  TrafficCone,
  Calendar,
} from 'lucide-react'
import { BimssHeader } from '@/components/bimss/BimssHeader'
import { BimssServiceTile } from '@/components/bimss/BimssServiceTile'

const SERVICES = [
  { title: 'DOCUMENT REQUEST', icon: FileText },
  { title: 'SOS ALERT', icon: Siren, glow: true },
  { title: 'PERMIT REQUEST', icon: ClipboardCheck },
  { title: 'INQUIRY', icon: HelpCircle },
  { title: 'NEWS', icon: Newspaper },
  { title: 'DIRECTORY', icon: BookUser },
  { title: 'BUSINESS', icon: Briefcase },
  { title: 'COMMUNITY', icon: Users },
  { title: 'TRAFFIC ACCIDENT', icon: TrafficCone },
  { title: 'EVENTS', icon: Calendar },
]

export function BimssPage() {
  return (
    <div className="min-h-screen pb-24">
      <BimssHeader title="MY BARANGAY" />

      <div className="px-4 py-5">
        <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
          {SERVICES.map((service) => (
            <BimssServiceTile
              key={service.title}
              title={service.title}
              icon={service.icon}
              to={`/bimss/coming-soon?title=${encodeURIComponent(service.title)}`}
              glow={'glow' in service && !!service.glow}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
